import { render, staticRenderFns } from "./goods_seckill.vue?vue&type=template&id=48be58b2&scoped=true"
import script from "./goods_seckill.vue?vue&type=script&lang=js"
export * from "./goods_seckill.vue?vue&type=script&lang=js"
import style0 from "./goods_seckill.vue?vue&type=style&index=0&id=48be58b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be58b2",
  null
  
)

export default component.exports